import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Typography,
  Chip,
} from "@material-ui/core";
import Telegram from "@material-ui/icons/Telegram";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {MeetingRoom, NoMeetingRoom, Phone, Place} from "@material-ui/icons";
import {makeStyles} from "@material-ui/core/styles";
import {useState} from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ChipList from "./ChipList";
import CustomImageCarousel from "./CustomImageCarousel";
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import NotInterestedIcon from '@material-ui/icons/NotInterested';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "27.33%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    "& .MuiSvgIcon-root": {
      color: theme.palette.text.secondary,
      marginRight: theme.spacing(1),
    },
  },
  secondaryHeading: {
    color: theme.palette.text.secondary,
    display: "inline-flex",
    flexWrap: "wrap",
    width: "100%",
    alignItems: "center",
    "& div": {
      marginRight: theme.spacing(2),
    },
  },
  boxWrapper: {
    display: "flex",
    flexDirection: "column",
    color: "rgba(0, 0, 0, 0.54)",
  },
  boxItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  disabled: {
    textDecoration: "line-through",
    opacity: 0.6,
  },
  validated: {
    backgroundColor: '#d5fbffff'
  },
  validatedButton: {
      color: '#f50057'
  },
  loadingWrapper: {
    background: "#fff",
    width: "100%",
    height: "80%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }
}));
export default function BranchCards({
  providerInfo,
  branches,
  isAdmin,
  onActionEmailSend,
  sendingEmailToBranch,
  activities,
  handleEdit,
  handleVisibility,
  handleDelete,
  handleValidate,
  showValidate,
  loading
}) {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(false);
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  const getChipItems = (items) => {
    return items?.map((activityId) => {
      const activity = activities?.find((a) => a._id === activityId);
      if (!activity) return null;
      if (activity.visibility) {
        return activity.name;
      }
      return <span className={classes.disabled}>{activity.name}</span>;
    });
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleActionEmailSend = (branch) => async () => {
    await onActionEmailSend(branch);
  };

  return (    
    <div className={classes.root}>
      {loading && (
        <div className={classes.loadingWrapper}>
          <CircularProgress />
        </div>
      )}
      {branches?.map((branch) => (
        <Accordion
          className={branch.manual_validation_flag ? classes.validated : ""}
          key={branch._id}
          expanded={expanded === branch._id}
          onChange={handleChange(branch._id)}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className={classes.heading}>
              {branch?.visibility ? <MeetingRoom /> : <NoMeetingRoom />}
              <Typography>{branch?.info?.name}</Typography>
            </div>
            <Box className={classes.secondaryHeading}>
              <div
                style={{ display: "flex", alignItems: "center", width: "50%" }}
              >
                <Place style={{ marginRight: "8px" }} />
                <Typography Wrap>
                  {[
                    branch?.info?.address?.address_line_1,
                    branch?.info?.address?.street,
                    branch?.info?.address?.area,
                    branch?.info?.address?.city,
                    branch?.info?.address?.state,
                    branch?.info?.address?.country,
                    branch?.info?.address?.zip_code,
                    !!branch?.info?.address?.landmark
                      ? "( near " + branch?.info?.address?.landmark + " )"
                      : "",
                  ].join(" ")}
                </Typography>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Phone style={{ marginRight: "8px" }} />
                <Typography Wrap>
                  {[
                    branch?.info?.contact?.contact_name,
                    branch?.info?.contact?.contact_role,
                    branch?.info?.contact?.contact_phone_number
                      ? "+ " + branch?.info?.contact?.contact_phone_number
                      : null,
                    branch?.info?.contact?.contact_email,
                  ].join(", ")}
                </Typography>
                {/* {branch?.info?.contact?.contact_phone_number} */}
              </div>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Box component="div" className={classes.boxWrapper}>
                  <div className="boxItem">{branch?.info?.description}</div>
                </Box>
              </Grid>
              <Grid item xs={12} md={9}>
                <ChipList
                  items={getChipItems(branch.activities)}
                  label="Activities"
                />
                <CustomImageCarousel
                  defaultCaption={branch?.info?.name}
                  images={branch?.images}
                  itemsToShow={4}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
          <Divider />
          <AccordionActions>
            {branch?.images.length ? <Chip
              label={
                branch?.generic_images_flag
                  ? "Generic Images"
                  : "Provider Images"
              }
              color="secondary"
              style={{
                backgroundColor: branch?.generic_images_flag
                  ? "#0097a7"
                  : "#666666",
                position: "absolute",
                left: 7,
              }}
            /> : ""}
            {isAdmin && (
              <Button
                size="small"
                onClick={handleActionEmailSend(branch)}
                variant="contained"
                color="secondary"
                disableElevation
                style={{
                  backgroundColor:
                    sendingEmailToBranch === branch._id ? "#666" : "#f50057",
                }}
                disabled={sendingEmailToBranch === branch._id}
              >
                {sendingEmailToBranch === branch._id ? (
                  <CircularProgress size={20} style={{ marginRight: 4 }} />
                ) : (
                  <Telegram style={{ marginRight: 4 }} />
                )}
                Send Welcome Email
              </Button>
            )}
            {showValidate && (
              <Button
                size="small"
                className={
                  branch.manual_validation_flag ? classes.validatedButton : ""
                }
                startIcon={
                  branch.manual_validation_flag ? (
                    <NotInterestedIcon />
                  ) : (
                    <ThumbUpIcon />
                  )
                }
                onClick={handleValidate(branch)}
              >
                {branch.manual_validation_flag ? "Invalidate" : "Validate"}
              </Button>
            )}
            <Button
              size="small"
              onClick={handleVisibility(branch)}
              startIcon={
                branch?.visibility ? <NoMeetingRoom /> : <MeetingRoom />
              }
            >
              {branch?.visibility ? "mark closed" : "mark open"}
            </Button>
            <Button
              size="small"
              color="secondary"
              startIcon={<DeleteIcon />}
              onClick={handleDelete(branch)}
            >
              Delete
            </Button>
            <Button
              size="small"
              startIcon={<EditIcon />}
              color="primary"
              onClick={handleEdit(branch)}
            >
              Edit
            </Button>
          </AccordionActions>
        </Accordion>
      ))}
    </div>
  );
}
